import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { ClimateMetricId, HeatWhen } from "../map/layers/climate";

/**
 * What the Climate pane is currently asking.
 *
 * The scenario and horizon drive the grid layer; `heatWhen` drives the heat
 * island, which is a different dataset at a different resolution and has no
 * scenario at all. Keeping them as separate state is the honest arrangement —
 * folding them together would imply the heat island is projected, which it is
 * not.
 */
interface ClimateState {
  metric: ClimateMetricId;
  /** "RCP2.6" | "RCP4.5" | "RCP8.5" — the emissions pathway. */
  scenario: string;
  /** "REF" | "H1" | "H2" | "H3". */
  horizon: string;
  setMetric: (metric: ClimateMetricId) => void;
  setScenario: (scenario: string) => void;
  setHorizon: (horizon: string) => void;

  heatWhen: HeatWhen;
  setHeatWhen: (heatWhen: HeatWhen) => void;
}

export const SCENARIOS = ["RCP2.6", "RCP4.5", "RCP8.5"];
export const HORIZONS = ["REF", "H1", "H2", "H3"];

export const useClimateStore = create<ClimateState>()(
  persist(
    (set) => ({
      // Mid-century under the middle pathway: the horizon a flat bought today
      // is still standing in, under the scenario that is neither wishful nor
      // worst-case.
      metric: "tropical_nights",
      scenario: "RCP4.5",
      horizon: "H2",
      setMetric: (metric) => set({ metric }),
      setScenario: (scenario) => set({ scenario }),
      setHorizon: (horizon) => set({ horizon }),

      heatWhen: "day",
      setHeatWhen: (heatWhen) => set({ heatWhen }),
    }),
    {
      name: "mete-climate",
      version: 1,
    },
  ),
);
